export const environment = {
  production: true,
  apiUrl: 'https://api.time-entry-helper.webops.exosource.com',
  connectwiseUrl: 'https://cw.exosource.com/v4_6_release/apis/3.0',
  webopsApiEndpoint: 'https://api.webops.exosource.com/api/v1',
  extensionStoreUrl: 'https://microsoftedge.microsoft.com/addons/detail/nomdhigllkbmecniebifmkohalfjcokn',
  graph: {
    uri: 'https://graph.microsoft.com/v1.0/me',
    scopes: [
      'user.read',
      'mail.read',
      'calendars.read',
      'chat.read',
      'CallEvents.Read',
      'OnlineMeetings.Read',
      'OnlineMeetingTranscript.Read.All',
      'Sites.Read.All',
    ],
  },
  cwCustomField: 12,
  internalCompanyId: 250

};
